import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/roles';
    import { Head } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreateRoles from '@/components/roles/CreateRoles.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { BreadcrumbItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Roles',
  setup(__props) {

    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.settings',
        },
        {
            title: 'menu.roles',
            href: route('v2.roles.index'),
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.ROLES],
        queryFn: getRoles,
    });

    async function getRoles() {
        const { data } = await axios.get(route('v2.roles.table'));
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('roles.page_header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).ROLES,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending),
              "default-column-visibility": {
                    id: false,
                }
            }, {
              title: _withCtx(() => [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('roles.page_header')), 1)
                  ]),
                  _: 1
                })
              ]),
              actions: _withCtx(() => [
                _createVNode(DataTableToolbarActions, { name: "roles" }, {
                  default: _withCtx(() => [
                    (_unref(hasPermission)(_unref(Permission).ROLES_CREATE))
                      ? (_openBlock(), _createBlock(CreateRoles, { key: 0 }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["table-key", "columns", "data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})